var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6632_135130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 20.0385H2.5C1.12167 20.0385 0 18.9169 0 17.5385V5.87183C0 4.4935 1.12167 3.37183 2.5 3.37183H9.16672C9.62753 3.37183 10 3.74521 10 4.20526C10 4.66516 9.62753 5.03854 9.16672 5.03854H2.5C2.03995 5.03854 1.66672 5.41269 1.66672 5.87183V17.5385C1.66672 17.9977 2.03995 18.3718 2.5 18.3718H14.1667C14.6266 18.3718 15 17.9977 15 17.5385V10.8718C15 10.4119 15.3725 10.0385 15.8333 10.0385C16.2941 10.0385 16.6667 10.4119 16.6667 10.8718V17.5385C16.6667 18.9169 15.545 20.0385 14.1667 20.0385Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4064 2.68604L7.81295 9.27936C7.75466 9.33765 7.71545 9.4118 7.69882 9.49176L7.10967 12.4385C7.08221 12.5751 7.12554 12.7159 7.22381 12.8151C7.303 12.8943 7.40966 12.9367 7.51891 12.9367C7.54546 12.9367 7.57308 12.9343 7.60055 12.9285L10.5464 12.3394C10.628 12.3226 10.7022 12.2835 10.7597 12.2251L17.3531 5.63174L14.4064 2.68604Z",
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3892 0.64846C18.5768 -0.16407 17.2551 -0.16407 16.4433 0.64846L15.29 1.80172L18.2359 4.74758L19.3892 3.59417C19.7825 3.20171 19.9992 2.67834 19.9992 2.1217C19.9992 1.56506 19.7825 1.04168 19.3892 0.64846Z",
    fill: "#42A5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6632_135130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.8bf3e44ba3a5b6b801c22ddf95fdae4a.svg";
export { ForwardRef as ReactComponent };